import { Map } from "immutable";
const { getGroupsForRoutes, getCategoriesForRoutes } = require("../../selectors/index");
const getGroupsAndCategories = (state) => {
    const groups = getGroupsForRoutes(state);
    const category = getCategoriesForRoutes(state);
    return Promise.resolve(Map({ groups, category }));
};
export { getGroupsAndCategories };
